import DebugBox from "components/shareable/DebugBox";
import Icon from "elements/Icon";
import useBrand from "Hooks/useBrand";
import useWebsiteBuilder, { WebsiteBuilderContent } from "Hooks/useWebsiteBuilder";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import { clsx, styx } from "modules/Utils";
import { CSSProperties } from "react";

interface WebsiteBuidlerRequiresPaidPlanProps {
    className?: string;
    style?: React.CSSProperties;
    title?: string;
    requiresPaidPlan: boolean;
    contentIndex: number;
    titleRequired?: string;
}

const WebsiteBuidlerRequiresPaidPlan = ({
    className,
    style,
    title = 'This website setting requires a paid plan to publish your website.',
    requiresPaidPlan,
    contentIndex,
}: WebsiteBuidlerRequiresPaidPlanProps) => {
    const {
        isPaidBrand,
        isGrandfathered,
    } = useBrand();

    const { websiteContent } = useWebsiteBuilder();

    if (isPaidBrand) {
        return null
    }

    if (!isGrandfathered) {
        return null
    }

    const content = websiteContent[contentIndex];
    const {
        isContentBackgroundColorEnabled,
        isContentSecondaryColorEnabled,
        isContentTextColorEnabled,
        isContentTextSecondaryColorEnabled
    } = content;

    if (
        !requiresPaidPlan &&
        !(
            isContentBackgroundColorEnabled ||
            isContentSecondaryColorEnabled ||
            isContentTextColorEnabled ||
            isContentTextSecondaryColorEnabled
        )
    ) {
        return null;
    }

    return (
        <div
            className={clsx(
                'websiteBuilderRequiresPaidPlanComponent',
                className
            )}
            style={styx(
                sty.websiteBuilderRequiresPaidPlanComponent,
                style
            )}
        >
            <Icon
                className="imageContentPaidPlanIcon"
                icon="gem"
                size={20}
                color={Colors.purple}
            />
            <div style={Sty.text14grey}>
                {title}
            </div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    websiteBuilderRequiresPaidPlanComponent: {
        display: 'flex',
        gap: 4,
        padding: 16,
        backgroundColor: Colors.greyLighter,
        borderRadius: 8,
    }
}

export default WebsiteBuidlerRequiresPaidPlan;